module.exports = __webpack_public_path__ + "img/glasstype-singlesunglasses.f4a3e9c9.svg";